export default "__VITE_ASSET__CQ_Gu8aY__"